import React from "react";

const RejectSuccess = ({ isRejectSuccessOpen, closeRejectSuccess }) => {
  return (
    <>
      <div
        className={`${
          isRejectSuccessOpen ? "flex" : "hidden"
        } flex items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="flex items-center justify-center w-full">
          <div className="relative bg-white shadow-lg rounded-sm w-[90%] max-w-[42%] mx-auto">
            <div className="mb-5 mx-auto items-center justify-center">
              <div
                onClick={closeRejectSuccess}
                className="absolute top-[5px] right-[10px] cursor-pointer text-[24px] flex items-center justify-center mt-1"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.74039 11.1602L5.60039 8.06016L3.80039 11.1602H0.100391L3.78039 5.46016L0.000390632 0.000155687H3.84039L5.98039 3.08016L7.78039 0.000155687H11.4804L7.74039 5.62016L11.5804 11.1602H7.74039Z"
                    fill="black"
                  />
                </svg>
              </div>
              <div className="w-full flex flex-col items-center mt-10">
                <p className="items-center text-center text-[#000000] font-[600] text-[16px] mt-2 mb-7">
                  SUCCESS!
                </p>

                <svg
                  width="83"
                  height="83"
                  viewBox="0 0 83 83"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M41.3333 82.6667C64.1611 82.6667 82.6667 64.1611 82.6667 41.3333C82.6667 18.5056 64.1611 0 41.3333 0C18.5056 0 0 18.5056 0 41.3333C0 64.1611 18.5056 82.6667 41.3333 82.6667Z"
                    fill="#8ED6A8"
                  />
                  <path
                    d="M23.25 36.1667L38.2023 51.119C38.3476 51.2641 38.5446 51.3457 38.75 51.3457C38.9554 51.3457 39.1524 51.2641 39.2977 51.119L80.0833 10.3333"
                    stroke="black"
                    stroke-width="1.2"
                  />
                </svg>

                <p className="items-center text-center font-[400] text-[14px] text-[#000000] mt-5">
                  Guarantorship successfully rejected
                </p>

                <button
                  onClick={closeRejectSuccess}
                  className="text-[#005C53] h-10 rounded-md mt-10 border border-[#005C53] px-16"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RejectSuccess;
